import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';

/**
 * Accessible label row with an optional marker or "optional" hint.
 *
 * When `optional` is `false` (default), a red `*` is appended.
 * When `optional` is `true`, an italic parenthetical hint is shown instead.
 *
 * @example
 * ```html
 * <lib-ui-form-label label="Company name" />
 * <lib-ui-form-label label="Middle name" [optional]="true" optionalLabel="If on ID" />
 * ```
 */
@Component({
  selector: 'lib-ui-form-label',
  imports: [CommonModule],
  template: `
    <div [ngClass]="labelClass()">
      <span>{{ label() }}</span>
      @if (optional()) {
        <span class="ml-3 italic">({{ optionalLabel() }})</span>
      }
      @if (!optional()) {
        <span class="text-red-500 text-sm">*</span>
      }
    </div>
  `,
})
export class FormLabel {
  /** Visible label text. */
  label = input.required<string>();

  /**
   * Tailwind classes applied to the wrapper `div`.
   * @defaultValue `'text-sm font-medium'`
   */
  labelClass = input<string>('text-sm font-medium');

  /**
   * When `true`, shows the `optionalLabel` hint instead of the red required `*`.
   * @defaultValue `false`
   */
  optional = input<boolean>(false);

  /**
   * Text shown in parentheses when `optional` is `true`.
   * @defaultValue `'Optional'`
   */
  optionalLabel = input('Optional');
}
